// Module
var code = `<template> <div class="page-attachment-viewer"> <partial-attachment-viewer entity-id.bind="entityId" entity-type-id.bind="entityTypeId" get-attachment-documents.bind="getAttachmentDocuments"></partial-attachment-viewer> </div> </template>`;
// Exports
module.exports = code;